module.exports = "<div ng-class=\"$ctrl.getClasses()\">\n  <div ng-repeat=\"option in $ctrl.optionsData\"\n      class=\"request-type-button pull-left\"\n      ng-class=\"$ctrl.getCssActive(option.value , $last)\"\n      ng-click=\"$ctrl.selectOption(option.value)\">\n      <p>{{option.text | translate}}</p>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/optionSwitch/optionSwitch.html
// module id = 993
// module chunks = 0